import React from 'react';
import PropTypes from 'prop-types';
import logoSended from '../../img/qr-sended.png';
import QrFirmLogo from './QrFirmLogo';
import QrFooter from './QrFooter';
import translation from './translation.json';
import logoBase from '../../img/qr-logo-base.png';

const ThanksOrAlreadyVoteQr = ({
  alreadyVote,
  lang,
  image,
  buttonClicked,
  link,
  businessLinkText
}) => {
  const thanks = alreadyVote
    ? translation.thanks[lang]
    : translation.thanks[lang];
  const message = alreadyVote
    ? translation.alreadyVote[lang]
    : translation.thanksWithOptions[lang][buttonClicked];

  return (
    <>
      <div className="container text-center">
        <QrFirmLogo image={image} />
        <img className="page-qr__sended-img" src={logoSended} alt="" />
        <h1 className="page-qr__sended-title">{thanks}</h1>
        <div className="page-qr__sended-subtitle-container">
          <p className="page-qr__sended-subtitle">
            {message}
            <br />
            {translation.haveANiceDay[lang]}
          </p>
        </div>
      </div>
      <div className="page-qr__feedback-container">
        <p className="page-qr__feedback-text">
          {translation.wantToCollect[lang]}
        </p>

        <p className="page-qr__feedback-text page-qr__buttom-logo">
          {translation.sendFeedbackWith[lang]}{' '}
          <a href="https://liketo.me/" target="_blank" rel="noreferrer">
            liketo.me
          </a>
        </p>
      </div>
      {link?.length > 0 && (
        <div className="page-qr__footer mb-1">
          <p className="support-help-text">
            {businessLinkText}&nbsp;
            <a href={link} target="_blank" rel="noopener noreferrer">
              Google Maps
            </a>
          </p>
        </div>
      )}
      <QrFooter developedIn={translation.developedIn[lang]} />
    </>
  );
};

export default ThanksOrAlreadyVoteQr;

ThanksOrAlreadyVoteQr.propTypes = {
  alreadyVote: PropTypes.bool,
  lang: PropTypes.string,
  image: PropTypes.shape({}),
  buttonClicked: PropTypes.string,
  link: PropTypes.string,
  businessLinkText: PropTypes.string
};

ThanksOrAlreadyVoteQr.defaultProps = {
  alreadyVote: false,
  lang: 'en',
  image: null,
  buttonClicked: null,
  link: '',
  businessLinkText: ''
};
